import { Helmet } from 'react-helmet-async';

import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// @mui
import { Stack, Paper, Container, Typography, Grid, CircularProgress, Box } from '@mui/material';

import PropTypes from 'prop-types';

import { GetCandidate } from 'src/components/services/httpServices';

import { AuthContext } from '../Context/Auth/auth.context';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CandidateDetails() {
  let { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [candidate, setCandidate] = useState({});
  let {
    authState: { deptId },
  } = useContext(AuthContext);
  const fetch = async (event) => {
    const savedCandidate = await GetCandidate(id);
    setCandidate(savedCandidate);
    setLoading(false);
  };
  useEffect(() => {
    fetch();
  }, []);

  return (
    <>
      <Helmet>
        <title> Candidate | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}></Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Grid container spacing={3}>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  First Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.firstName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Last Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.lastName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Contact :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.contact}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Email Address :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.email}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Father Name :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.fatherName}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Address :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.address}
                </Typography>
              </Grid>

              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Identity Type :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.identityType}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Identity No :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.identityNumber}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Identity Expiry:{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.identityExpiry?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Marital Status :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.maritalStatus}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Gender :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.gender}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Blood Group :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.bloodGroup}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Date of Birth :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.dateOfBirth?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Joining Date :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.joiningDate?.split('T')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3}>
                <Typography variant="h6" color="initial">
                  Recruitment Method :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.recruitmentMethod}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reffered By :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.refferedBy}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reference 1 :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.reference1}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reference 2 :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.reference2}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={3} md={3} hidden>
                <Typography variant="h6" color="initial">
                  Reference 3 :{' '}
                </Typography>
                <Typography variant="subtitle" color="initial">
                  {candidate?.reference3}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </Container>
    </>
  );
}
